import { findAvailableLotMatch } from './lotIdentity'

type AvailableLot = {
  id: string
  lotKey: string
  stage?: string
}

export type UnmappedLotUiState = {
  unmappedLot: string
  hasUnmappedLot: boolean
  unresolvedLotStatus: 'matched' | 'ambiguous' | 'unmatched'
  isAmbiguousLot: boolean
  canMapToExisting: boolean
  canCreateNewLot: boolean
}

export const resolveUnmappedLotUiState = (args: {
  unmappedLotLabel: unknown
  availableLots: AvailableLot[]
}): UnmappedLotUiState => {
  const unmappedLot = String(args.unmappedLotLabel ?? '').trim()
  if (!unmappedLot) {
    return {
      unmappedLot: '',
      hasUnmappedLot: false,
      unresolvedLotStatus: 'unmatched',
      isAmbiguousLot: false,
      canMapToExisting: false,
      canCreateNewLot: false
    }
  }

  const unresolvedLotStatus = args.availableLots.length > 0
    ? findAvailableLotMatch(unmappedLot, args.availableLots).status
    : 'unmatched'

  return {
    unmappedLot,
    hasUnmappedLot: true,
    unresolvedLotStatus,
    isAmbiguousLot: unresolvedLotStatus === 'ambiguous',
    canMapToExisting: args.availableLots.length > 0,
    canCreateNewLot: unresolvedLotStatus === 'unmatched'
  }
}